import React from 'react';
import './AdminCSS/deviceupdate.css'; // Reusing same styles

const PatientUpdate = ({ formData, setFormData, handleUpdateSubmit, setSelectedPatient }) => {
  return (
    <div className="popup-device">
      <h3>Update Patient</h3>

      <label htmlFor="name">Name:</label>
      <input
        type="text"
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        placeholder="Patient Name"
        required
      />

      <label htmlFor="age">Age:</label>
      <input
        type="number"
        value={formData.age}
        onChange={(e) => setFormData({ ...formData, age: e.target.value })}
        placeholder="Patient Age"
        required
      />

      <label htmlFor="gender">Gender:</label>
      <select
        value={formData.gender}
        onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
        required
      >
        <option value="">Select Gender</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
        <option value="other">Other</option>
      </select>

      <button onClick={handleUpdateSubmit}>Submit</button>
      <button onClick={() => setSelectedPatient(null)}>Cancel</button>
    </div>
  );
};

export default PatientUpdate;
